import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import AlertError from '@mui/icons-material/Error';

const iconStyles = {
  width: 45,
  height: 45,
  verticalAlign: 'bottom'
};

const RequestLoginErrorMessage = ({ message, onlyMessage = false }) => (
  <div className="login-error-message">
    {
      !onlyMessage ?
      <Paper>
        <div className="error-page">
          <div className="title">5<span><AlertError style={iconStyles} /></span>0</div>
          <h4 className="message">{message}</h4>
        </div>
      </Paper>
      :
        <h2>{message}</h2>
    }
  </div>
);

RequestLoginErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
  onlyMessage: PropTypes.bool
};

export default RequestLoginErrorMessage;
